<template>
  <Card
    :class="$style.container"
    noBorder
  >
    <ParagraphBody data-test-id="CheckoutCard__subTotalText">
      Cart Subtotal ({{ addOnsCount }} items): <strong>${{ addOnsSubTotal }}/user/mo</strong>
    </ParagraphBody>
    <Button
      data-test-id="CheckoutCard__proceedToCheckoutButton"
      text="Proceed To Checkout"
      @click="handleProceedToCheckoutClicked"
    />
    <CartPackageRecommendation
      :class="$style.recommendationPopup"
      data-test-id="CheckoutCard__popUp"
      v-on="$listeners"
    />
  </Card>
</template>

<script>
import {
  Button,
  Card,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapGetters } from 'vuex';
import CartPackageRecommendation from 'client/Pricing/ALaCarte/CartPackageRecommendation.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import PaymentHelper from 'client/Payments/PaymentHelper';

const {
  description,
  location,
  text,
  section,
} = eventProperties;
const {
  pricingPage,
} = eventLocations;

const checkoutModel = 'CheckoutModel';

export default {
  name: 'CheckoutCard',

  EventHelper,

  components: {
    Button,
    Card,
    CartPackageRecommendation,
    ParagraphBody,
  },

  computed: {
    ...mapGetters(checkoutModel, {
      addOnsSubTotal: 'getAddOnsSubTotal',
      allAddOns: 'getAllAddOns',
    }),

    addOnsCount() {
      return this.allAddOns.length;
    },
  },

  methods: {
    handleProceedToCheckoutClicked() {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: 'admin has built his/her custom A La Carte package and is proceeding to checkout',
        [text]: 'Proceed To Checkout',
        [location]: pricingPage,
        [section]: 'A La Carte cart',
      });
      PaymentHelper.openCheckoutModal(pricingPage);
    },
  },
};
</script>

<style module scoped>
.container {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.recommendationPopup {
  margin-top: -2.5rem;
}
</style>
